// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Set content for font-families */
.ql-font-arial,
.ql-font span[data-value="arial"]::before {
  font-family: Arial, sans-serif;
}

.ql-font-comic-sans,
.ql-font span[data-value="comic-sans"]::before {
  font-family: "Comic Sans MS", cursive, sans-serif;
}

.ql-font-courier-new,
.ql-font span[data-value="courier-new"]::before {
  font-family: "Courier New";
}

.ql-font-georgia,
.ql-font span[data-value="georgia"]::before {
  font-family: Georgia, serif;
}

.ql-font-helvetica,
.ql-font span[data-value="helvetica"]::before {
  font-family: Helvetica, sans-serif;
}

.ql-font-lucida,
.ql-font span[data-value="lucida"]::before {
  font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
}

/* Set content for sizes */
.ql-size-extra-small,
.ql-size span[data-value="extra-small"]::before {
  font-size: 13px !important;
}

.ql-size-small,
.ql-size span[data-value="small"]::before {
  font-size: 14px !important;
}

.ql-size-medium,
.ql-size span[data-value="medium"]::before {
  font-size: 18px !important;
}

.ql-size-large,
.ql-size span[data-value="large"]::before {
  font-size: 20px !important;
}




#root .ql-container {
  background: #f00;
  margin: 2px 0px 8px 0px;

  /* height: calc(100% - 56px);
  min-height: calc(100% - 56px);
  max-height: calc(100% - 56px); */

  height: 100%;
  min-height: 100%;
  max-height: 100%;  
    
  /* justify-content: space-between; */
 
  /* flex: 1;
  display: flex; 
  flex-direction: column; */
 
}

#root .ql-container.ql-snow {
  border: unset
}

#root .ql-toolbar.ql-snow {
  padding: 16px 8px 0px 8px;
}

#root .ql-snow.ql-toolbar {
  /* border-radius: var(--radius-small); */
  min-height: 56px;
  max-height: 56px;
  
  align-items: center;
  justify-content: space-between;
  /* background-color: var(--button-bg); */

  border: 1px solid var(--separation-color);

  /* border-radius: var(--radius-medium); */
  box-shadow: 0px 0px 6px 1px var(--button-bg);
  /* box-shadow: 0px 0px 6px 1px var(--button-bg); */
  /* border: unset;  */
  box-sizing: border-box;

  /* background: var(--button-bg);
  min-height: 56px;  
  align-items: center;
  justify-content: space-between;
  background-color: var(--button-bg);
  border-radius: var(--radius-medium);
  box-shadow: 0px 0px 6px 1px var(--button-bg);
  border: unset;  */
}

#root .ql-editor {  
  flex: 0 1;
  overflow-y: scroll;
  width: 100%;

  /* min-height: 18em; */
  height: 100%;
  min-height: 100%;
  max-height: 100%;

  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  /* border-radius: var(--radius-small); */
  /* overflow-y: scroll; */
  /* overflow: hidden auto ; */
  /* overflow-wrap: break-word; */
  /* overflow-x: scroll; */

  /* min-height: 200px !important;   */

  /* float: left;
  width: 100%; */
  /* height: 100% important; */
}

/* 
.ql-editor {
  overflow-y: scroll;
  resize: vertical;
}

#root {
  margin: 1rem 4rem;
}

#root .ql-container {
  border-bottom-left-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  background: #fefcfc;
}


#root .ql-snow.ql-toolbar {
  display: block;
  background: #eaecec;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
}

#root .ql-editor {
  min-height: 18em;
} */`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Main/Editor/Editor.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,+DAA+D;AACjE;;AAEA,0BAA0B;AAC1B;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;;;;AAKA;EACE,gBAAgB;EAChB,uBAAuB;;EAEvB;;kCAEgC;;EAEhC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;;EAEhB,oCAAoC;;EAEpC;;2BAEyB;;AAE3B;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;;EAExC,yCAAyC;;EAEzC,yCAAyC;EACzC,4CAA4C;EAC5C,kDAAkD;EAClD,oBAAoB;EACpB,sBAAsB;;EAEtB;;;;;;;mBAOiB;AACnB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,WAAW;;EAEX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;;EAEhB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;EACxC,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;;EAExB,oCAAoC;;EAEpC;gBACc;EACd,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG","sourcesContent":["/* Set content for font-families */\r\n.ql-font-arial,\r\n.ql-font span[data-value=\"arial\"]::before {\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.ql-font-comic-sans,\r\n.ql-font span[data-value=\"comic-sans\"]::before {\r\n  font-family: \"Comic Sans MS\", cursive, sans-serif;\r\n}\r\n\r\n.ql-font-courier-new,\r\n.ql-font span[data-value=\"courier-new\"]::before {\r\n  font-family: \"Courier New\";\r\n}\r\n\r\n.ql-font-georgia,\r\n.ql-font span[data-value=\"georgia\"]::before {\r\n  font-family: Georgia, serif;\r\n}\r\n\r\n.ql-font-helvetica,\r\n.ql-font span[data-value=\"helvetica\"]::before {\r\n  font-family: Helvetica, sans-serif;\r\n}\r\n\r\n.ql-font-lucida,\r\n.ql-font span[data-value=\"lucida\"]::before {\r\n  font-family: \"Lucida Sans Unicode\", \"Lucida Grande\", sans-serif;\r\n}\r\n\r\n/* Set content for sizes */\r\n.ql-size-extra-small,\r\n.ql-size span[data-value=\"extra-small\"]::before {\r\n  font-size: 13px !important;\r\n}\r\n\r\n.ql-size-small,\r\n.ql-size span[data-value=\"small\"]::before {\r\n  font-size: 14px !important;\r\n}\r\n\r\n.ql-size-medium,\r\n.ql-size span[data-value=\"medium\"]::before {\r\n  font-size: 18px !important;\r\n}\r\n\r\n.ql-size-large,\r\n.ql-size span[data-value=\"large\"]::before {\r\n  font-size: 20px !important;\r\n}\r\n\r\n\r\n\r\n\r\n#root .ql-container {\r\n  background: #f00;\r\n  margin: 2px 0px 8px 0px;\r\n\r\n  /* height: calc(100% - 56px);\r\n  min-height: calc(100% - 56px);\r\n  max-height: calc(100% - 56px); */\r\n\r\n  height: 100%;\r\n  min-height: 100%;\r\n  max-height: 100%;  \r\n    \r\n  /* justify-content: space-between; */\r\n \r\n  /* flex: 1;\r\n  display: flex; \r\n  flex-direction: column; */\r\n \r\n}\r\n\r\n#root .ql-container.ql-snow {\r\n  border: unset\r\n}\r\n\r\n#root .ql-toolbar.ql-snow {\r\n  padding: 16px 8px 0px 8px;\r\n}\r\n\r\n#root .ql-snow.ql-toolbar {\r\n  /* border-radius: var(--radius-small); */\r\n  min-height: 56px;\r\n  max-height: 56px;\r\n  \r\n  align-items: center;\r\n  justify-content: space-between;\r\n  /* background-color: var(--button-bg); */\r\n\r\n  border: 1px solid var(--separation-color);\r\n\r\n  /* border-radius: var(--radius-medium); */\r\n  box-shadow: 0px 0px 6px 1px var(--button-bg);\r\n  /* box-shadow: 0px 0px 6px 1px var(--button-bg); */\r\n  /* border: unset;  */\r\n  box-sizing: border-box;\r\n\r\n  /* background: var(--button-bg);\r\n  min-height: 56px;  \r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: var(--button-bg);\r\n  border-radius: var(--radius-medium);\r\n  box-shadow: 0px 0px 6px 1px var(--button-bg);\r\n  border: unset;  */\r\n}\r\n\r\n#root .ql-editor {  \r\n  flex: 0;\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n\r\n  /* min-height: 18em; */\r\n  height: 100%;\r\n  min-height: 100%;\r\n  max-height: 100%;\r\n\r\n  background-color: #f8f8f8;\r\n  border: 1px solid #e0e0e0;\r\n  /* border-radius: var(--radius-small); */\r\n  /* overflow-y: scroll; */\r\n  /* overflow: hidden auto ; */\r\n  /* overflow-wrap: break-word; */\r\n  /* overflow-x: scroll; */\r\n\r\n  /* min-height: 200px !important;   */\r\n\r\n  /* float: left;\r\n  width: 100%; */\r\n  /* height: 100% important; */\r\n}\r\n\r\n/* \r\n.ql-editor {\r\n  overflow-y: scroll;\r\n  resize: vertical;\r\n}\r\n\r\n#root {\r\n  margin: 1rem 4rem;\r\n}\r\n\r\n#root .ql-container {\r\n  border-bottom-left-radius: 0.5em;\r\n  border-bottom-right-radius: 0.5em;\r\n  background: #fefcfc;\r\n}\r\n\r\n\r\n#root .ql-snow.ql-toolbar {\r\n  display: block;\r\n  background: #eaecec;\r\n  border-top-left-radius: 0.5em;\r\n  border-top-right-radius: 0.5em;\r\n}\r\n\r\n#root .ql-editor {\r\n  min-height: 18em;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
